export function requestErrorMessage(error, fallback = "The request could not be completed. Please try again.") {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail;
  if (Array.isArray(detail)) {
    const messages = detail.map(item => typeof item?.msg === "string" ? item.msg : "").filter(Boolean);
    if (messages.length) return messages.join(" ");
  }
  if (typeof detail?.message === "string") return detail.message;
  return fallback;
}
